import {
  HabitSchedule,
  ScheduleEntryState,
  UpcomingPeriod,
} from '@griply/types';
import { isSameDay } from 'date-fns';

export const buildPeriodRestoreSchedules = (
  schedules: HabitSchedule[],
  period: UpcomingPeriod,
): HabitSchedule[] | null => {
  const datesToRestore = period.days
    .filter(
      (day) => day.entry?.hidden && day.entry.state === ScheduleEntryState.Skip,
    )
    .map((d) => d.date);

  if (!datesToRestore.length) {
    return null;
  }

  return schedules.map((schedule) => {
    const newEntries = schedule.entries.filter(
      (entry) => !datesToRestore.some((date) => isSameDay(date, entry.date)),
    );

    const newSkips =
      schedule.skips?.filter(
        (skip) => !datesToRestore.some((date) => isSameDay(date, skip)),
      ) ?? [];

    return {
      ...schedule,
      entries: newEntries,
      skips: newSkips,
    };
  });
};
